import { message } from 'antd';
import { call, put, takeEvery, all, fork } from 'redux-saga/effects'
import { FETCH_MIPS, FETCH_MIPS_START, FETCH_MIPS_SUCCESS, FETCH_MIPS_ERROR,
ADD_MIP, ADD_MIP_SUCCESS, ADD_MIP_ERROR, UPDATE_MIP, UPDATE_MIP_SUCCESS, UPDATE_MIP_ERROR
} from "../../actions/admin/mipsAction";
import { HIDE_MODAL, SUBMIT_START, SUBMIT_ERROR } from "../../actions/admin/modalActions";
import { getMipsAPI, addUpdateMipAPI } from "../../../services/mips-service";

function* fetchMips({risId}) {
    try {
        yield put({ type: FETCH_MIPS_START })
        const response = yield call(getMipsAPI, risId);
        if (response.success) {
            yield put({ type: FETCH_MIPS_SUCCESS, mips: response.mip })
        } else {
            yield put({ type: FETCH_MIPS_ERROR, error: response.error })
            message.error('Failed to fetch sites!');
        }
    } catch (error) {
        yield put({ type: FETCH_MIPS_ERROR, error })
        message.error('Failed to fetch sites!');
    }
}

function* addMip({ mip }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(addUpdateMipAPI, mip);
        if (response.success) {
            yield put({ type: ADD_MIP_SUCCESS, mip: response.mip })
            yield put({ type: HIDE_MODAL })
            message.success('Site created successfully.');
        } else {
            yield put({ type: ADD_MIP_ERROR, error: response.error })
            yield put({ type: SUBMIT_ERROR })
            if(typeof response.error === "string"){
                message.error(response.error);
            }else{
                message.error('Failed to create site!');
            }
        }
    } catch (error) {
        yield put({ type: ADD_MIP_ERROR, error })
        yield put({ type: SUBMIT_ERROR })
        message.error('Failed to create site!');
    }
}

function* updateMip({ mip }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(addUpdateMipAPI, mip);
        if (response.success) {
            yield put({ type: UPDATE_MIP_SUCCESS, mip })
            yield put({ type: HIDE_MODAL })
            message.success('Site info updated successfully.');
        } else {
            yield put({ type: UPDATE_MIP_ERROR, error: response.error })
            yield put({ type: SUBMIT_ERROR })
            if(typeof response.error === "string"){
                message.error(response.error);
            }else{
                message.error('Failed to update site info!');
            }
        }
    } catch (error) {
        yield put({ type: UPDATE_MIP_ERROR, error })
        yield put({ type: SUBMIT_ERROR })
        message.error('Failed to update site info!');
    }
}

function* mipsWatcher() {
    yield takeEvery(FETCH_MIPS, fetchMips)
    yield takeEvery(ADD_MIP, addMip)
    yield takeEvery(UPDATE_MIP, updateMip)
}

export default function* rootSaga() {
    yield all([
        mipsWatcher(),
    ]);
}